import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { ConnectionType } from '../connection.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class ConnectionTypesResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  query(params?: QueryParams): Observable<ConnectionType[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<ConnectionType[]>(`${this.apiRoot}/${account_id}/api/connections/types`, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('ConnectionTypes', downgradeInjectable(ConnectionTypesResource));
